const EyeIcon = (props: any) => {
    return <img {...props} alt="eye.png" src={require('./eye.png')} />;
};

export default EyeIcon;
